import { colors, ui } from '@beelday/common'
import type { Excalidraw as ExcalidrawComponent } from '@pragmatic-brains/excalidraw'
import { Spinner } from 'common/presentation/spinner'
import { ComponentPropsWithoutRef } from 'react'

/**
 * The whiteboard library, loaded the first time a board renders. Imported
 * statically it was evaluated at app start, and its bundled browser-fs-access
 * fetched a code chunk right away - on every device, phones included, that
 * never shows a board. See `ui.importUmdExport` for what loading it lazily
 * takes in a production build.
 */
export const Excalidraw = ui.lazyWithRetry<
	ComponentPropsWithoutRef<typeof ExcalidrawComponent>
>(
	() =>
		ui.importUmdExport(
			() => import('@pragmatic-brains/excalidraw'),
			module => module.Excalidraw
		),
	{ fallback: <Spinner color={colors.indigoBlue} /> }
)
